export default "__VITE_ASSET__fd2a585c__"